// extracted by mini-css-extract-plugin
export var boldText = "_33-4";
export var checkboxContainer = "_33-6";
export var closeIcon = "_33-i";
export var container = "_33-0";
export var drawer = "_33-8";
export var drawerContent = "_33-9";
export var extraSmallText = "_33-5";
export var fulfillmentGroupTable = "_33-e";
export var largeText = "_33-3";
export var loadingSpinnerContainer = "_33-j";
export var mediumText = "_33-2";
export var narrow = "_33-f";
export var notificationLink = "_33-l";
export var packageCheckIconContainer = "_33-7";
export var slideoutHeaderActions = "_33-g";
export var slideoutHeaderActionsShifted = "_33-h";
export var slideoutHeaderContainer = "_33-a";
export var slideoutModal = "_33-c";
export var stickyHeaderWrapper = "_33-b";
export var table = "_33-k";
export var tableContainer = "_33-d";
export var tertiaryText = "_33-1";